'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _react = require('react');
var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');
var _selectWrapper = require('../components/select/select-wrapper');
var _selectWrapper2 = _interopRequireDefault(_selectWrapper);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _objectWithoutProperties(obj, keys) {
  var target = {};
  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }
  return target;
}
Age.propTypes = {
  min: _propTypes.number.isRequired,
  max: _propTypes.number.isRequired,
  label: _propTypes.string
};
Age.defaultProps = {
  label: 'How old are you?'
};
function Age(_ref) {
  var min = _ref.min,
    max = _ref.max,
    label = _ref.label,
    rest = _objectWithoutProperties(_ref, ['min', 'max', 'label']);
  var options = [];
  for (var i = min; i <= max; i++) {
    options.push(i.toString());
  }
  return _react2.default.createElement(_selectWrapper2.default, Object.assign({
    label: label,
    placeholder: 'Please select',
    name: 'age',
    options: options
  }, rest));
}
exports.default = Age;